export enum ValidationError {
    EmptySelection,
    InprogressExist,
    TechnicalIssue,
}

export enum PropertySelectionStatus {
    Publishing = 0,
    Active = 1,
    Importable = 2,
    ImportableFromRoomUrl = 3,
    Draft = 4,
}
